import {
  Box,
  Button,
  Chip,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import { information } from "../../constants/locationData";
import { setNavBarInputFields } from "../../app/store/reducer";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Footer from "../../common/Footer";
import { useNavigate } from "react-router";
import MenuIcon from "@mui/icons-material/Menu";
import { routePath } from "../../constants/routePath";
import { getAllJob, getAllJobsMarketplace } from "./jobListApi";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import user from "../../assets/icon/UserJob.png";
import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import SortIcon from "@mui/icons-material/FilterList";

export default function JobFilter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const locations = ["Pune", "Sambhajinagar"];

  const designations = ["Hair Dresser"];
  const joinWithin = ["Immediate", "15", "30", "60"];
  const skills = ["Hair Cut"];

  const [selectedList, setSelectedList] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [selectedJoinWithin, setSelectedJoinWithin] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);

  // ....
  const [filters, setFilters] = useState({
    location: ["Pune"],
    skill: [],
    joinWithin: [],
    designation: [],
  });

  const [searchText, setSearchText] = useState("");
  const [activeFilter, setActiveFilter] = useState(null);
  // "location" | "skill" | "joinWithin"

  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields,
  );
  const toggleSelection = (item, selectedList, setSelectedList) => {
    if (selectedList.includes(item)) {
      setSelectedList(selectedList.filter((i) => i !== item));
    } else {
      setSelectedList([...selectedList, item]);
    }
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  // ........................

  const [allJobs, setAllJobs] = useState([]);

  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));
  const token = sessionStorage.getItem("smbToken");

  const fetchAllJobsMarketplace = async (appliedFilters = filters) => {
    try {
      const payload = {
        billerId: billerId || 0,
        filter: "",
        search1: [{ value: appliedFilters.location.join(",") }],
        search2: [{ value: appliedFilters.skill.join(",") }],
        search3: [{ value: appliedFilters.joinWithin.join(",") }],
        search4: [{ value: appliedFilters.designation.join(",") }],
      };
      console.log("Job billerd ", billerId);

      // const res = await getAllJobsMarketplace(payload);
      if (token) {
        getAllJob(payload, (data) => {
          setAllJobs(data.data.data.list);
        });
      } else {
        getAllJobsMarketplace(payload, (data) => {
          setAllJobs(data.data.data.list);
        });
      }
    } catch (error) {
      console.error("Failed to fetch jobs", error);
    }
  };

  useEffect(() => {
    fetchAllJobsMarketplace(filters);
  }, [filters]);

  const HandleValidation = () => {
    if (token) {
      navigate(`/myjobprofile`);
    } else {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
    }
  };
  const removeChip = (type, value) => {
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].filter((item) => item !== value),
    }));
  };
  const joinOptions = ["Immediate", "15", "30", "60"];

  return (
    <Box sx={{ fontFamily: "'Montserrat', sans-serif", minHeight: "100vh" }}>
      {isMobile && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            mb: { xs: 0, sm: 2 },
            px: 2,
          }}
        >
          <IconButton onClick={() => setMobileSidebarOpen(true)}>
            <SortIcon
              sx={{
                fontSize: "32px", // custom pixel size
                cursor: "pointer",
                color: "#000", // optional
              }}
            />
          </IconButton>
        </Box>
      )}

      {/* Mobile view */}

      <Drawer
        anchor="left"
        open={mobileSidebarOpen}
        onClose={() => setMobileSidebarOpen(false)}
        PaperProps={{
          sx: {
            width: "80%",
            padding: "16px",
            boxSizing: "border-box",
          },
        }}
      >
        <Box
          onClick={() => setMobileSidebarOpen(false)}
          sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
        >
          <IconButton>
            <ClearIcon />
          </IconButton>
        </Box>

        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              background: "white",
              padding: "15px",
              borderRadius: "10px",
              boxShadow: "0px 4px 4px 0px #00000040",
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            {/* Search Box */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #01008B",
                borderRadius: "15px",
                overflow: "hidden",
              }}
            >
              <TextField
                placeholder={
                  activeFilter === "location"
                    ? "Search Location"
                    : activeFilter === "skill"
                      ? "Search Skill"
                      : activeFilter === "joinWithin"
                        ? "Join Within (15 / 30 / 60)"
                        : "Select filter"
                }
                fullWidth
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  backgroundColor: "#fff",
                  "& .MuiInputBase-input": {
                    padding: "7.5px 10px !important",
                    fontFamily: "Kanit",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { border: "none" },
                    "&:hover fieldset": { border: "none" },
                    "&.Mui-focused fieldset": { border: "none" },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#585858",
                    opacity: 1,
                  },
                }}
                onChange={(e) => {
                  if (!activeFilter) return;
                  setSearchText(e.target.value);
                }}
                value={searchText}
                InputProps={{
                  readOnly: !activeFilter,
                }}
              />
              <Button
                variant="contained"
                sx={{
                  borderRadius: "0 14px 14px 0",
                  padding: "8px 16px",
                }}
              >
                <SearchIcon
                  sx={{
                    cursor: activeFilter ? "pointer" : "not-allowed",
                    //   color: (theme) => theme.palette.primary.main,
                  }}
                  onClick={() => {
                    if (!activeFilter || !searchText.trim()) return;

                    setFilters((prev) => ({
                      ...prev,
                      [activeFilter]: prev[activeFilter].includes(searchText)
                        ? prev[activeFilter]
                        : [...prev[activeFilter], searchText],
                    }));

                    setSearchText("");
                    //   handleClose();
                  }}
                />
              </Button>
            </Box>

            <Divider sx={{ backgroundColor: "#01008B", my: 2 }} />

            {/* Location */}

            <Box mb={5}>
              <Typography
                sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                onClick={() => {
                  setActiveFilter("location");
                  setSearchText("");
                }}
              >
                Location (City)
              </Typography>

              <Box display="flex" gap={1} flexWrap="wrap">
                {filters?.location.length > 0 ? (
                  filters?.location.map((item) => (
                    <Chip
                      key={item}
                      label={item}
                      onDelete={() => removeChip("location", item)}
                      deleteIcon={<CloseIcon />}
                      sx={{
                        backgroundColor: "#CECEFF",
                        color: "#01008B",
                        fontWeight: 500,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                      }}
                    />
                  ))
                ) : (
                  <Chip
                    label="Search here"
                    icon={<SearchIcon />}
                    clickable
                    onClick={() => {
                      setActiveFilter("location");
                      setSearchText("");
                    }}
                    sx={{
                      backgroundColor: "#CECEFF",
                      color: "#01008B",
                      fontWeight: 500,
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                    }}
                  />
                )}
              </Box>
            </Box>

            {/* Designation */}
            <Box mb={5}>
              <Typography
                sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                onClick={() => {
                  setActiveFilter("designation");
                  setSearchText("");
                }}
              >
                Designation
              </Typography>

              <Box display="flex" gap={1} flexWrap="wrap">
                {filters?.designation.length > 0 ? (
                  filters?.designation.map((item) => (
                    <Chip
                      key={item}
                      label={item}
                      onDelete={() => removeChip("designation", item)}
                      deleteIcon={<CloseIcon />}
                      sx={{
                        backgroundColor: "#CECEFF",
                        color: "#01008B",
                        fontWeight: 500,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                      }}
                    />
                  ))
                ) : (
                  <Chip
                    label="Search here"
                    icon={<SearchIcon />}
                    clickable
                    onClick={() => {
                      setActiveFilter("designation");
                      setSearchText("");
                    }}
                    sx={{
                      backgroundColor: "#CECEFF",
                      color: "#01008B",
                      fontWeight: 500,
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                    }}
                  />
                )}
              </Box>
            </Box>

            {/* Join Within */}
            <Box mb={5}>
              <Typography
                sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                onClick={() => {
                  setActiveFilter("joinWithin");
                  setSearchText("");
                }}
              >
                Join within
              </Typography>

              <Box display="flex" gap={1} flexWrap="wrap">
                {joinOptions?.map((item) => {
                  const isSelected = filters?.joinWithin.includes(item);
                  const toggleItem = () => {
                    setFilters((prev) => ({
                      ...prev,
                      joinWithin: isSelected
                        ? prev.joinWithin.filter((i) => i !== item)
                        : [...prev.joinWithin, item],
                    }));
                  };

                  return (
                    <Chip
                      key={item}
                      label={item}
                      onDelete={isSelected ? toggleItem : undefined}
                      deleteIcon={isSelected ? <CloseIcon /> : undefined}
                      onClick={toggleItem}
                      sx={{
                        backgroundColor: isSelected ? "#CECEFF" : "#fff",
                        color: "#01008B",
                        fontWeight: 500,
                        cursor: "pointer",
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.12)",

                        "&:hover": {
                          backgroundColor: isSelected ? "#CECEFF" : "#CECEFF",
                        },
                      }}
                    />
                  );
                })}
              </Box>
            </Box>
            {/* JSkills */}

            <Box mb={5}>
              <Typography
                sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                onClick={() => {
                  setActiveFilter("skill");
                  setSearchText("");
                }}
              >
                Skills
              </Typography>

              <Box display="flex" gap={1} flexWrap="wrap">
                {filters?.skill.length > 0 ? (
                  filters?.skill.map((item) => (
                    <Chip
                      key={item}
                      label={item}
                      onDelete={() => removeChip("skill", item)}
                      deleteIcon={<CloseIcon />}
                      sx={{
                        backgroundColor: "#CECEFF",
                        color: "#01008B",
                        fontWeight: 500,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                      }}
                    />
                  ))
                ) : (
                  <Chip
                    label="Search here"
                    icon={<SearchIcon />}
                    clickable
                    onClick={() => {
                      setActiveFilter("skill");
                      setSearchText("");
                    }}
                    sx={{
                      backgroundColor: "#CECEFF",
                      color: "#01008B",
                      fontWeight: 500,
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Drawer>

      <Grid container spacing={{ xs: 0, sm: 2 }} py={{ sm: 2, xs: 0 }}>
        {/* Sidebar */}

        {/* Desktop View */}
        {!isMobile && (
          <Grid item xs={6} sm={3}>
            <Box
              sx={{
                background: "white",
                padding: "15px",
                borderRadius: "10px",
                boxShadow: "0px 4px 4px 0px #00000040",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              {/* Search Box */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #01008B",
                  borderRadius: "15px",
                  overflow: "hidden",
                }}
              >
                <TextField
                  placeholder={
                    activeFilter === "location"
                      ? "Search Location"
                      : activeFilter === "skill"
                        ? "Search Skill"
                        : activeFilter === "joinWithin"
                          ? "Join Within (15 / 30 / 60)"
                          : "Select filter"
                  }
                  fullWidth
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    backgroundColor: "#fff",
                    "& .MuiInputBase-input": {
                      padding: "7.5px 10px !important",
                      fontFamily: "Kanit",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { border: "none" },
                      "&:hover fieldset": { border: "none" },
                      "&.Mui-focused fieldset": { border: "none" },
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#585858",
                      opacity: 1,
                    },
                  }}
                  onChange={(e) => {
                    if (!activeFilter) return;
                    setSearchText(e.target.value);
                  }}
                  value={searchText}
                  InputProps={{
                    readOnly: !activeFilter,
                  }}
                />
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: "0 14px 14px 0",
                    padding: "8px 16px",
                  }}
                >
                  <SearchIcon
                    sx={{
                      cursor: activeFilter ? "pointer" : "not-allowed",
                      //   color: (theme) => theme.palette.primary.main,
                    }}
                    onClick={() => {
                      if (!activeFilter || !searchText.trim()) return;

                      setFilters((prev) => ({
                        ...prev,
                        [activeFilter]: prev[activeFilter].includes(searchText)
                          ? prev[activeFilter]
                          : [...prev[activeFilter], searchText],
                      }));

                      setSearchText("");
                      //   handleClose();
                    }}
                  />
                </Button>
              </Box>

              <Divider sx={{ backgroundColor: "#01008B", my: 2 }} />

              {/* Location */}

              <Box mb={5}>
                <Typography
                  sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                  onClick={() => {
                    setActiveFilter("location");
                    setSearchText("");
                  }}
                >
                  Location (City)
                </Typography>

                <Box display="flex" gap={1} flexWrap="wrap">
                  {filters?.location.length > 0 ? (
                    filters?.location.map((item) => (
                      <Chip
                        key={item}
                        label={item}
                        onDelete={() => removeChip("location", item)}
                        deleteIcon={<CloseIcon />}
                        sx={{
                          backgroundColor: "#CECEFF",
                          color: "#01008B",
                          fontWeight: 500,
                          boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                        }}
                      />
                    ))
                  ) : (
                    <Chip
                      label="Search here"
                      icon={<SearchIcon />}
                      clickable
                      onClick={() => {
                        setActiveFilter("location");
                        setSearchText("");
                      }}
                      sx={{
                        backgroundColor: "#CECEFF",
                        color: "#01008B",
                        fontWeight: 500,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                      }}
                    />
                  )}
                </Box>
              </Box>

              {/* Designation */}
              <Box mb={5}>
                <Typography
                  sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                  onClick={() => {
                    setActiveFilter("designation");
                    setSearchText("");
                  }}
                >
                  Designation
                </Typography>

                <Box display="flex" gap={1} flexWrap="wrap">
                  {filters?.designation.length > 0 ? (
                    filters?.designation.map((item) => (
                      <Chip
                        key={item}
                        label={item}
                        onDelete={() => removeChip("designation", item)}
                        deleteIcon={<CloseIcon />}
                        sx={{
                          backgroundColor: "#CECEFF",
                          color: "#01008B",
                          fontWeight: 500,
                          boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                        }}
                      />
                    ))
                  ) : (
                    <Chip
                      label="Search here"
                      icon={<SearchIcon />}
                      clickable
                      onClick={() => {
                        setActiveFilter("designation");
                        setSearchText("");
                      }}
                      sx={{
                        backgroundColor: "#CECEFF",
                        color: "#01008B",
                        fontWeight: 500,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                      }}
                    />
                  )}
                </Box>
              </Box>

              {/* Join Within */}
              <Box mb={5}>
                <Typography
                  sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                  onClick={() => {
                    setActiveFilter("joinWithin");
                    setSearchText("");
                  }}
                >
                  Join within
                </Typography>

                <Box display="flex" gap={1} flexWrap="wrap">
                  {joinOptions?.map((item) => {
                    const isSelected = filters?.joinWithin.includes(item);
                    const toggleItem = () => {
                      setFilters((prev) => ({
                        ...prev,
                        joinWithin: isSelected
                          ? prev.joinWithin.filter((i) => i !== item)
                          : [...prev.joinWithin, item],
                      }));
                    };

                    return (
                      <Chip
                        key={item}
                        label={item}
                        onDelete={isSelected ? toggleItem : undefined}
                        deleteIcon={isSelected ? <CloseIcon /> : undefined}
                        onClick={toggleItem}
                        sx={{
                          backgroundColor: isSelected ? "#CECEFF" : "#fff",
                          color: "#01008B",
                          fontWeight: 500,
                          cursor: "pointer",
                          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.12)",

                          "&:hover": {
                            backgroundColor: isSelected ? "#CECEFF" : "#CECEFF",
                          },
                        }}
                      />
                    );
                  })}
                </Box>
              </Box>
              {/* JSkills */}

              <Box mb={5}>
                <Typography
                  sx={{ fontWeight: 600, mb: 1, cursor: "pointer" }}
                  onClick={() => {
                    setActiveFilter("skill");
                    setSearchText("");
                  }}
                >
                  Skills
                </Typography>

                <Box display="flex" gap={1} flexWrap="wrap">
                  {filters?.skill.length > 0 ? (
                    filters?.skill.map((item) => (
                      <Chip
                        key={item}
                        label={item}
                        onDelete={() => removeChip("skill", item)}
                        deleteIcon={<CloseIcon />}
                        sx={{
                          backgroundColor: "#CECEFF",
                          color: "#01008B",
                          fontWeight: 500,
                          boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                        }}
                      />
                    ))
                  ) : (
                    <Chip
                      label="Search here"
                      icon={<SearchIcon />}
                      clickable
                      onClick={() => {
                        setActiveFilter("skill");
                        setSearchText("");
                      }}
                      sx={{
                        backgroundColor: "#CECEFF",
                        color: "#01008B",
                        fontWeight: 500,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          sm={9}
          // pl={{ xs: 10, sm: 0 }}
          px={{ xs: 2, sm: 3 }}
        >
          <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
            {allJobs.map((job) => (
              <Grid item xs={12} sm={6} md={6} key={job.id}>
                <Box
                  onClick={() => navigate(`/apply/${job.id}`)}
                  sx={{
                    p: 2.5,
                    borderRadius: 2,
                    backgroundColor: "#EAEAFF",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {/* Left Content */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "16px", sm: "22px", md: "27px" },
                        fontWeight: 600,
                        display: "-webkit-box",
                        WebkitLineClamp: 1, // number of lines
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {job.designation || "-"}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: { xs: "13px", sm: "16px", md: "18px" },
                        fontWeight: 500,
                        mt: 0.5,
                      }}
                    >
                      {job.enterpriseName}
                    </Typography>

                    <Box sx={{ mt: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 0.5,
                          gap: 2,
                        }}
                      >
                        <Box
                          component="img"
                          src={location}
                          alt="Location"
                          sx={{ width: 20, height: 20 }}
                        />
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            fontWeight: 500,
                          }}
                        >
                          {job.preferredLocation}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 0.5,
                          gap: 2,
                        }}
                      >
                        <Box
                          component="img"
                          src={rupees}
                          alt="Salary"
                          sx={{ width: 20, height: 20 }}
                        />
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            fontWeight: 500,
                          }}
                        >
                          ₹{job.minSalary} – ₹{job.maxSalary} / month
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Box
                          component="img"
                          src={vacancy}
                          alt="Vacancies"
                          sx={{ width: 20, height: 20 }}
                        />
                        <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                          {job.noOfVacancies} Vacancies
                        </Typography>
                      </Box>

                      {job.hasApplied && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 12,
                            right: 16,
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                          }}
                        >
                          <CheckCircleIcon
                            sx={{ fontSize: 16, color: "#2ECC71" }}
                          />
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: 600,
                              color: "#2ECC71",
                            }}
                          >
                            Already Applied
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>

                  {/* Right Icon */}
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      backgroundColor: "#E6E8FF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                    }}
                  >
                    <Box
                      borderRadius={10}
                      component="img"
                      src={job.logoPath}
                      height={50}
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ pt: 10 }}>
        <Footer />
      </Box>
    </Box>
  );
}
